import { CreateOrderSheetOrderItemInput, OrderPromotionType } from '../../graphql/select-option_types.2';
import type { CreateOrderItemParams } from '../../type/common.type';

/**
 * 1+N 정보를 추가합니다
 * @param order_item - 주문 아이템
 * @param promotion_applied_discount_price - 옵션 가격
 * @param params - 주문 아이템 생성 파라미터
 * @param context - 옵션 정보
 * @returns 프로모션 적용 정보를 추가한 주문 아이템
 */
export const applyBogoPromotion = (
  order_item: CreateOrderSheetOrderItemInput,
  promotion_applied_discount_price: number,
  params: CreateOrderItemParams,
  context: { is_additional_option: boolean },
): CreateOrderSheetOrderItemInput => {
  const { is_additional_option } = context;

  if (params.bogo_info?.required_quantity && !is_additional_option) {
    order_item.grouping_required_quantity = params.bogo_info.required_quantity + 1;
    order_item.promotion_applied_info = {
      promotion_applied_discount_price,
      promotion_id: params.promotion_info?.promotion_id ?? '',
      promotion_type: params.promotion_info?.promotion_type as unknown as OrderPromotionType,
    };
  }

  return order_item;
};

/**
 * 1+N 프로모션 할인가 계산
 * ex) 10000원을 3개로 분배 → 3333, 3333, 3334
 * @param totalPrice - 총 가격
 * @param quantity - 수량
 * @returns 할인 금액
 */
export const distributeBogoPrice = (totalPrice: number, quantity: number): number[] => {
  const basePrice = Math.floor(totalPrice / quantity); // 기본 가격 (소수점 버림)
  const remainder = totalPrice % quantity; // 나머지

  const prices: number[] = [];

  // 모든 상품에 기본 가격 할당
  for (let i = 0; i < quantity; i++) {
    prices.push(basePrice);
  }

  // 마지막 상품에 나머지 추가
  if (remainder > 0) {
    prices[quantity - 1] += remainder;
  }

  return prices;
};
